import React, { Component } from 'react'
import { render } from 'react-dom'


class Search extends React.Component {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.closeModal = this.closeModal.bind(this);
    this.showAll = this.showAll.bind(this);
    this.focusText = this.focusText.bind(this);
    this.focusTextOut = this.focusTextOut.bind(this);
  }

  state = {
    searchString: '',
    showSuggestions: false,
    allDestinations: false,
    text_cosi: Drupal.t("Destination"),
    text_entry_point: false
  }



  handleChange = (e) => {
    this.setState({
      searchString: e.target.value
    });
    if (e.target.value.length > 0) {
      this.setState({
        showSuggestions: true
      });
    }
    else {
      this.props.setFlexi({
        ppt_fast: '',
        sabre_property_id: '',
        fastbooking_property_id: ''
      });
      if (this.props.setOpeningDate) {
        this.props.setOpeningDate('');
      }
      this.setState({
        showSuggestions: false,
        allDestinations: true
      });
    }
  }

  handleClick = (property) => {
    this.setState({
      searchString: property.title,
      showSuggestions: false
    })
    this.props.setBookNowUrl(property.book_now_url);
    if (this.props.setOpeningDate) {
      this.props.setOpeningDate(property.opening_date || '');
    }

    var flexData = {
      ppt_fast: property.title,
      sabre_property_id: property.field_sabre_property_id,
      fastbooking_property_id: property.field_fastbooking_property_id
    };
    this.props.setFlexi(flexData);
  }

  showAll = (e) => {
    this.setState({
      searchString: ''
    })
  }

  closeModal = (e) => {
    this.setState({
      showSuggestions: false
    })
  }

  focusText = () => {
    this.setState({
      text_cosi: Drupal.t("Enter a Destination or Hotel"),
      text_entry_point: true,
      showSuggestions: true
    })
  };

  focusTextOut = () => {
    drupalSettings.ajaxPageState.theme === "centara_cosi" ?
    this.setState({
      text_cosi: <div className="cosi_text">{Drupal.t("WHERE")} <span>{ Drupal.t("TO ?")}</span></div>,
      text_entry_point: false
    }):
    this.setState({
      text_cosi: Drupal.t("Destination"),
      text_entry_point: false
    })
  }
  handleClickOutside = event => {
    if(!event.target.classList.contains("booknow-show-text")) {
      this.setState({
        showSuggestions: false
      })
    }
  }
  componentDidMount = () => {
    document.addEventListener('click', this.handleClickOutside, true);

    if(drupalSettings.ajaxPageState.theme === "centara_cosi") {
      this.setState({
        text_cosi: <div className="cosi_text">{Drupal.t("WHERE")} <span>{ Drupal.t("TO ?")}</span></div>
      });
    }
  }
  render() {
    const {
      state: {
        showSuggestions,
      }
    } = this;

    var cityName = [];
    var countryName = [];
    var temp = [];
    if (drupalSettings.is_sabre) {
      var properties = JSON.parse(drupalSettings.centara_sabre.booknow_property_data);
    }
    else {
      var properties = JSON.parse(drupalSettings.centara_fastbooking.booknow_property_data);
    }
    var searchString = this.state.searchString.trim().toLowerCase();
    if (searchString.length > 0) {
      // Filter list properties by country name
      const propertiesCountry = properties.filter(data => {
        return data.country_name.toLowerCase().match( searchString );
      });
      // Filter list properties by city name
      const propertiesCity = properties.filter(data => {
        return data.city_name.toLowerCase().match( searchString );
      });
      // Filter list properties by title
      const propertiesTitle= properties.filter(data => {
        return data.title.toLowerCase().match( searchString );
      });
      // Remove duplicate items from 3 list above
      const propertiesUnique = [];
      properties = [...propertiesCountry, ...propertiesCity, ...propertiesTitle];
      properties = properties.filter(data => {
        if (!propertiesUnique.includes(data.ppty_id)) {
          propertiesUnique.push(data.ppty_id);
          return true;
        }
        return false;
      });
    }

    let suggestionsListComponent;

    if(showSuggestions) {
      suggestionsListComponent = (
        <ul className="booknow-show-text">
          {
            properties.map((property, index) => {
              if ((temp.indexOf(property.city_name) < 0) && (property.city_name !== "")) {
                temp.push(property.city_name);
                cityName = <div className="city"> {property.city_name} </div>;
              }
              else {
                cityName = ''
              }
              if (temp.indexOf(property.country_name) < 0) {
                temp.push(property.country_name);
                countryName = <div className="booknow-show-text country">{property.country_name} </div>;
              }
              else {
                countryName = ''
              }
              return (
                <li className="booknow-show-text" key = {index} >
                  {countryName}
                  {cityName}
                  <div className = "booknow-show-text property-search-name" onClick = {() => this.handleClick(property)} > {property.title} </div>
                </li>
              );
            })
          }
          {this.state.allDestinations ?(<div className = "booknow-show-text view-all btn--primary" onClick = {this.showAll}>{drupalSettings.ajaxPageState.theme === "centara_cosi" ? Drupal.t("See all Destinations & Hotels"): Drupal.t("All Destinations & Hotels")}</div>): ''}
        </ul>
      );
    }

    return (
      <div className = {"destination-input" + (this.state.showSuggestions ? '' : ' ') + ' ' + (this.state.text_entry_point?'input-style' : "")}>
        <div className = "close-btn" onClick={this.closeModal}></div>
        <label> {this.state.text_cosi} </label>
        <div className = "input-wrapper">
          {this.state.searchString ? (
            <span
              className="search-icon clear"
              onClick={() =>
                this.setState(
                  {
                    searchString: '',
                    showSuggestions: false
                  },
                  () => {
                    this.props.setFlexi({
                      ppt_fast: '',
                      sabre_property_id: '',
                      fastbooking_property_id: ''
                    });
                    if (this.props.setOpeningDate) {
                      this.props.setOpeningDate('');
                    }
                  }
                )
              }
            >
            </span>
          ) : (
            <span className="search-icon"></span>
          )}
          <div className = "search-autofilter">
            <input className="booknow-show-text" name="booknow-search-text" type = "text" onBlur={this.focusTextOut} onClick={this.focusText} value = {this.state.searchString || ""} onChange = {this.handleChange} placeholder = { Drupal.t("Enter a Destination or Hotel") } style={ this.props.isHotel ? {} : {borderColor: '#B5121B'}} />
            <div className = "search-wrapper">
              {suggestionsListComponent}
            </div>
          </div>

          <span className={'error text-primary-red ' + (this.props.isHotel ? 'visually-hidden' : '')}>{Drupal.t("Please select a hotel")}</span>
        </div>
        <div className="done-button btn--primary booknow-show-text" onClick={this.closeModal}> {Drupal.t("Done")}</div>
      </div>
    );
  }
}

export default Search;
